export const STONES = [
  {
    slug: "quartz-slabs",
    number: "01",
    name: "Quartz Slabs",
    signature: true,
    origin: "Engineered perfection",
    description:
      "Our signature collection. Non-porous, scratch-resistant and endlessly consistent — quartz slabs bring the drama of natural stone to kitchens, counters and walls without the upkeep.",
    finishes: ["Polished", "Matte", "Leathered"],
    image:
      "https://images.unsplash.com/photo-1682888813913-e13f18692019?q=85&w=1080",
    aspect: "aspect-[4/5]",
  },
  {
    slug: "italian-marble",
    number: "02",
    name: "Italian Marble",
    origin: "Carrara & beyond, Italy",
    description:
      "Calacatta, Statuario, Botticino — the stones that built Rome and dressed the Renaissance, hand-selected at the quarry for vein, tone and translucency.",
    finishes: ["Polished", "Honed"],
    image:
      "https://images.unsplash.com/photo-1558346648-9757f2fa4474?q=80&w=1080",
    aspect: "aspect-[3/4]",
  },
  {
    slug: "indian-marble",
    number: "03",
    name: "Indian Marble",
    origin: "Rajnagar & Makrana, India",
    description:
      "From the same Makrana quarries that gave the world the Taj Mahal — luminous whites and soft greys with a warmth only Indian marble carries.",
    finishes: ["Polished", "Honed", "Brushed"],
    image:
      "https://images.unsplash.com/photo-1551554781-c46200ea959d?q=80&w=1080",
    aspect: "aspect-[16/10]",
  },
  {
    slug: "granite",
    number: "04",
    name: "Granite",
    origin: "South India",
    description:
      "Forged under pressure, finished for generations. Absolute blacks, steel greys and speckled classics that shrug off heat, time and traffic.",
    finishes: ["Polished", "Flamed", "Leathered"],
    image:
      "https://images.unsplash.com/photo-1652305461546-bf0a76934433?q=80&w=1080",
    aspect: "aspect-[4/5]",
  },
  {
    slug: "imported-onyx",
    number: "05",
    name: "Imported Onyx",
    origin: "Turkey, Iran & Brazil",
    description:
      "Stone that glows. Backlit honey, amber and smoke-toned onyx that turns a wall into a light source and a counter into theatre.",
    finishes: ["Polished", "Backlit-ready"],
    image:
      "https://images.unsplash.com/photo-1534947379496-bedc63409670?q=85&w=1080",
    aspect: "aspect-[3/4]",
  },
  {
    slug: "imported-granite",
    number: "06",
    name: "Imported Granite",
    origin: "Brazil & Norway",
    description:
      "Rare exotics — deep blues, cosmic blacks and river-washed golds sourced from the world's most storied granite belts.",
    finishes: ["Polished", "Leathered"],
    image:
      "https://images.unsplash.com/photo-1550053808-52a75a05955d?q=80&w=1080",
    aspect: "aspect-[16/10]",
  },
  {
    slug: "natural-onyx",
    number: "07",
    name: "Natural Onyx",
    origin: "Select Indian belts",
    description:
      "Banded by millennia of mineral springs, natural onyx carries landscapes inside it — rust, ivory and ember in a single slab.",
    finishes: ["Polished", "Honed"],
    image:
      "https://images.unsplash.com/photo-1511109520219-fec6140bf9d8?q=85&w=1080",
    aspect: "aspect-[4/5]",
  },
];

export const STONE_DETAILS = {
  "quartz-slabs": {
    seoTitle: "Quartz Slabs in Gurgaon — KalingaStone & Paradigm Quartz | Varun Marbles",
    seoDesc:
      "Premium quartz slabs in Gurgaon. Authorised dealers for KalingaStone Quartz and Paradigm Quartz — non-porous, scratch-resistant slabs for kitchens, counters and walls.",
    intro:
      "Our signature material. Quartz pairs the drama of natural stone with engineered consistency — no sealing, no staining, no surprises. We stock the two houses we trust most: KalingaStone and Paradigm.",
    brands: [
      {
        name: "KalingaStone Quartz",
        rangeKey: "kalinga",
        logo: "/assets/brands/kalingastone.png",
        blurb:
          "India's most awarded engineered stone — deep, book-matched veins and colours calibrated for Indian light and kitchens.",
        varieties: [
          {
            name: "Staturio Extra",
            note: "Brilliant white with bold grey veining — the flagship Statuario interpretation.",
            image: "/assets/stones/kalinga-staturio-extra.jpg",
          },
          {
            name: "Miraggio Gold",
            note: "Warm gold veining drifting over a soft white base.",
            image: "/assets/stones/kalinga-miraggio-gold.jpg",
          },
          {
            name: "Marquina Ultra",
            note: "Deep black struck with white veins — pure drama for counters and walls.",
            image: "/assets/stones/kalinga-marquina-ultra.jpg",
          },
        ],
      },
      {
        name: "Paradigm Quartz",
        rangeKey: "paradigm",
        logo: "/assets/brands/paradigm.png",
        blurb:
          "Design-forward surfaces with a matte, contemporary sensibility — made for architects who specify every detail.",
        varieties: [
          {
            name: "Carrara Golden Shower",
            note: "Carrara Series — soft white with golden-grey veining. Large 320 × 163 cm slabs.",
            image: "/assets/stones/paradigm-carrara-golden-shower.jpg",
          },
          {
            name: "Calacatta Rivero Gold",
            note: "Calacatta Series — river-like gold veins flowing across a white field.",
            image: "/assets/stones/paradigm-calacatta-rivero-gold.jpg",
          },
          {
            name: "Mayra Gold",
            note: "Warm gold movement with a premium matte sensibility. 320 × 163 cm slabs.",
            image: "/assets/stones/paradigm-mayra-gold.jpg",
          },
        ],
      },
    ],
  },
  "italian-marble": {
    seoTitle: "Italian Marble in Gurgaon — Calacatta, Statuario, Carrara | Varun Marbles",
    seoDesc:
      "Imported Italian marble in Gurgaon: Calacatta Gold, Statuario, Carrara and Botticino slabs, hand-selected at Italian quarries. View the collection at Varun Marbles.",
    intro:
      "The stone of Rome and the Renaissance. We select blocks at the quarries of Carrara and beyond — for vein clarity, tone and that unmistakable translucence only Italian marble carries.",
    varieties: [
          {
            name: "Statuario",
            note: "Bright white with dramatic grey strokes — sculpture-grade Italian marble.",
            image: "/assets/stones/pro-statuario.jpg",
          },
          {
            name: "Calacatta Vagli",
            note: "Bold gold-grey veining on ivory — Italy's most coveted look.",
            image: "/assets/stones/pro-calacatta-vagli.jpg",
          },
          {
            name: "Panda White",
            note: "Black brushstroke veins on white — a modern icon.",
            image: "/assets/stones/pro-panda-white.jpg",
          },
          {
            name: "Flawless White",
            note: "Near-pure white with the faintest silver drift.",
            image: "/assets/stones/pro-flawless-white.jpg",
          },
          {
            name: "Bianco Oro",
            note: "White warmed with golden threads — elegant and versatile.",
            image: "/assets/stones/pro-bianco-oro.jpg",
          },
          {
            name: "New Perlato Royal",
            note: "Classic Sicilian beige — floors that feel like old hotels.",
            image: "/assets/stones/pro-perlato-royal.jpg",
          },
        ],
  },
  "indian-marble": {
    seoTitle: "Indian Marble in Gurgaon — Makrana, Rajnagar & More | Varun Marbles",
    seoDesc:
      "Premium Indian marble — Makrana white, Rajnagar and Rainforest varieties. The same stone family that built the Taj Mahal, curated by Varun Marbles, Gurgaon.",
    intro:
      "From Makrana — the quarries that gave the world the Taj Mahal — come luminous whites and soft greys with a warmth imported stone can't imitate. Indian marble is heritage you can walk on.",
    varieties: [
          {
            name: "Makrana White",
            note: "The Taj Mahal stone — pure, luminous white from Rajasthan.",
            image: "/assets/stones/pro-makrana-white.jpg",
          },
          {
            name: "Makrana Albeta",
            note: "Creamy white with soft grey figuring — Makrana's refined cousin.",
            image: "/assets/stones/pro-makrana-albeta.jpg",
          },
          {
            name: "Katni Pink",
            note: "Warm rose-beige waves — India's most loved floor stone.",
            image: "/assets/stones/pro-katni-pink.jpg",
          },
          {
            name: "Makrana Dungri",
            note: "Soft grey veining over Makrana white — the workhorse of the Taj quarries.",
            image: "/assets/stones/pro-makrana-dungri.jpg",
          },
          {
            name: "Morwad White",
            note: "Milky white with gentle grey drift — Kishangarh's quiet classic.",
            image: "/assets/stones/pro-morwad-white.jpg",
          },
          {
            name: "Banswara White",
            note: "White silk threaded with purple-grey veins — Rajasthan's answer to Statuario.",
            image: "/assets/stones/pro-banswara-white.jpg",
          },
          {
            name: "Rainforest Green",
            note: "Deep green crossed by branch-like brown veins — a forest frozen in stone.",
            image: "/assets/stones/pro-rainforest-green.jpg",
          },
          {
            name: "Rainforest Brown",
            note: "Ember-brown with rust-red veining — earthy, bold and unmistakably Indian.",
            image: "/assets/stones/pro-rainforest-brown.jpg",
          },
        ],
  },
  granite: {
    seoTitle: "Granite in Gurgaon — Absolute Black, Steel Grey, Tan Brown | Varun Marbles",
    seoDesc:
      "South Indian granite slabs in Gurgaon — Absolute Black, Steel Grey, Tan Brown and Kashmir White. Heat-proof, traffic-proof, finished for generations at Varun Marbles.",
    intro:
      "Forged under pressure, finished for generations. Our South Indian granites shrug off heat, knives and decades of traffic — the workhorse that still turns heads.",
    varieties: [
          {
            name: "Absolute Black",
            note: "Deep, even black from Karnataka — the sharpest counter surface there is.",
            image: "/assets/stones/pro-absolute-black.jpg",
          },
          {
            name: "Black Galaxy",
            note: "Ongole's midnight black sprinkled with gold stars.",
            image: "/assets/stones/pro-black-galaxy.jpg",
          },
          {
            name: "Tan Brown",
            note: "Chestnut and black crystals — the workhorse of family kitchens.",
            image: "/assets/stones/pro-tan-brown.jpg",
          },
          {
            name: "Steel Grey",
            note: "Cool silver-grey speckle — understated, urban, endlessly versatile.",
            image: "/assets/stones/pro-steel-grey.jpg",
          },
          {
            name: "Kashmir White",
            note: "Frost-white with garnet specks — Kashmir's most exported beauty.",
            image: "/assets/stones/pro-kashmir-white.jpg",
          },
          {
            name: "Viscount White",
            note: "Silver waves rolling over ice — movement without noise.",
            image: "/assets/stones/pro-viscount-white.jpg",
          },
          {
            name: "Paradiso",
            note: "Swirling plum-grey clouds — South India's most dramatic granite.",
            image: "/assets/stones/pro-paradiso.jpg",
          },
          {
            name: "Red Multicolour",
            note: "Rose-red currents over grey — a celebration stone from Tamil Nadu.",
            image: "/assets/stones/pro-red-multicolour.jpg",
          },
        ],
  },
  "imported-onyx": {
    seoTitle: "Imported Onyx in Gurgaon — Honey, White & Green Onyx | Varun Marbles",
    seoDesc:
      "Imported onyx from Turkey, Iran and Brazil — backlit honey, white and green onyx slabs that turn walls into light. At Varun Marbles, Gurgaon.",
    intro:
      "Stone that glows. Imported onyx is translucent — backlight it and a wall becomes a light source, a counter becomes theatre. Sourced from Turkey, Iran and Brazil.",
    varieties: [
          {
            name: "White Onyx",
            note: "Glacial translucence — pure light when backlit.",
            image: "/assets/stones/pro-white-onyx.jpg",
          },
          {
            name: "Honey Onyx",
            note: "Golden amber bands — the classic backlit showpiece.",
            image: "/assets/stones/pro-honey-onyx.jpg",
          },
          {
            name: "Green Onyx",
            note: "Jade and mint ribbons — cool, rare and luminous.",
            image: "/assets/stones/pro-green-onyx.jpg",
          },
          {
            name: "Pink Onyx",
            note: "Blush translucence — made for powder rooms and bars.",
            image: "/assets/stones/pro-pink-onyx.jpg",
          },
        ],
  },
  "imported-granite": {
    seoTitle: "Imported Granite in Gurgaon — Blue Pearl, Cosmic Black | Varun Marbles",
    seoDesc:
      "Rare imported granite in Gurgaon — Blue Pearl from Norway, Cosmic Black and river-gold exotics from Brazil. Curated by Varun Marbles.",
    intro:
      "The exotics. Deep blues from Norway, cosmic blacks and river-washed golds from Brazil — granites so rare your neighbour won't have them.",
    varieties: [
          {
            name: "Blue Pearl",
            note: "Norwegian midnight-blue crystals that catch light like water.",
            image: "/assets/stones/pro-blue-pearl.jpg",
          },
          {
            name: "Alaska White",
            note: "Brazilian ice-white scattered with onyx speckles.",
            image: "/assets/stones/pro-alaska-white.jpg",
          },
          {
            name: "Blue Bahia",
            note: "Electric ocean blue — Brazil's most exotic granite.",
            image: "/assets/stones/pro-blue-bahia.jpg",
          },
          {
            name: "Azul Macaubas",
            note: "Sky-blue waves — a collector's stone.",
            image: "/assets/stones/pro-azul-macaubas.jpg",
          },
          {
            name: "Labradorite",
            note: "Iridescent blue-green flash over deep charcoal.",
            image: "/assets/stones/pro-labradorite.jpg",
          },
          {
            name: "Colonial White",
            note: "Cotton-white with smoky grey drift — serene and bright.",
            image: "/assets/stones/pro-colonial-white.jpg",
          },
          {
            name: "Angola Black",
            note: "Volcanic black with silver crystals — Africa's midnight stone.",
            image: "/assets/stones/pro-angola-black.jpg",
          },
          {
            name: "Nero Impala",
            note: "South Africa's deep charcoal classic — sleek and uniform.",
            image: "/assets/stones/pro-nero-impala.jpg",
          },
          {
            name: "Black Zimbabwe",
            note: "Pure midnight grain — the blackest canvas for any kitchen.",
            image: "/assets/stones/pro-black-zimbabwe.jpg",
          },
          {
            name: "Baltic Brown",
            note: "Finland's coffee-brown crystals ringed in black — warm and timeless.",
            image: "/assets/stones/pro-baltic-brown.jpg",
          },
          {
            name: "Bianco Sardo",
            note: "Sardinian salt-and-pepper — crisp, bright and effortlessly clean.",
            image: "/assets/stones/pro-bianco-sardo.jpg",
          },
          {
            name: "Rosa Beta",
            note: "Blush-pink Sardinian granite — soft colour, hard stone.",
            image: "/assets/stones/pro-rosa-beta.jpg",
          },
          {
            name: "Emerald Pearl",
            note: "Norwegian green-silver crystals that shimmer like deep water.",
            image: "/assets/stones/pro-emerald-pearl.jpg",
          },
        ],
  },
  "natural-onyx": {
    seoTitle: "Natural Onyx in Gurgaon — Banded Honey, Ivory Cloud | Varun Marbles",
    seoDesc:
      "Natural onyx slabs in Gurgaon — banded by millennia of mineral springs, in honey, ivory and ember tones. At Varun Marbles.",
    intro:
      "Banded by millennia of mineral springs, natural onyx carries whole landscapes inside it — rust, ivory and ember in a single slab. No two pieces are ever alike.",
    varieties: [
          {
            name: "Green Wave Onyx",
            note: "Jade waves rolling through the slab.",
            image: "/assets/stones/natonyx-green-wave.jpg",
          },
          {
            name: "Tiger Onyx",
            note: "Amber and bronze stripes with wild energy.",
            image: "/assets/stones/natonyx-tiger.jpg",
          },
          {
            name: "Sunrise Onyx",
            note: "Dawn-coloured bands — peach to gold.",
            image: "/assets/stones/natonyx-sunrise.jpg",
          },
          {
            name: "Mexican Red Onyx",
            note: "Deep terracotta shot with lightning veins.",
            image: "/assets/stones/natonyx-mexican-red.jpg",
          },
          {
            name: "Black Onyx",
            note: "Pure midnight — sleek and endless.",
            image: "/assets/stones/natonyx-black.jpg",
          },
        ],
  },
};

export const HERO_TEXTURE =
  "https://images.unsplash.com/photo-1566305977571-5666677c6e98?q=80&w=1080";
